import React from "react";
import Container from "./components/container";
import "./App.css";

function App() {
  return <Container />;
}

export default App;
